module.exports = __webpack_public_path__ + "static/events-details-522137fa0dfaca0f78485f32f9b81c32.jpg";